module.exports = __webpack_public_path__ + "assets/images/80d8796556db103a60af1a0b7e01c369.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/operate-with-zen.webp
// module id = 415
// module chunks = 0